module.exports = __webpack_public_path__ + "static/media/dramaImg10.ce7ac012.jpg";